import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api } from '../../app/api'
import {id} from "date-fns/locale";

export const getUserData = createAsyncThunk(
  'user/getUserData',
  async ({ token }) => {
    api.defaults.headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    const response = await api.get('/user');
    return response.data;
  }
)

export const changeEmail = createAsyncThunk(
  'user/changeEmail',
  async ({ token, email }) => {
    api.defaults.headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    const response = await api.patch('/user', { email })
    return response.data
  }
)

export const changeNotifications = createAsyncThunk(
    'user/changeEmail',
    async ({ token, notifications }) => {
        api.defaults.headers = {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        const response = await api.patch('/user', { notifications })
        return response.data
    }
)

export const changePhone = createAsyncThunk(
  'user/changeEmail',
  async ({ token, phoneNumber, code }) => {
    api.defaults.headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    const response = await api.patch('/user', { phoneNumber: phoneNumber, smsCode: code })
    return response.data
  }
)

export const changeAvatar = createAsyncThunk(
    'user/changeAvatar',
    async (formData) => {
        const response = await api.post('/user/avatar', formData)
        return response.data
    }
)

export const deleteAvatar = createAsyncThunk(
    'user/deleteAvatar',
    async () => {
        const response = await api.delete('/user/avatar')
        return response.data
    }
)

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    isLoaded: false,
    user: {},
    error: {
      failed: false,
      message: null,
    },
  },
  extraReducers: {
    [getUserData.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [getUserData.fulfilled]: (state, action) => {
      state.isLoaded = true;
      state.user = action.payload
    },
    [getUserData.rejected]: (state, action) => {
      state.isLoaded = true;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [changePhone.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [changePhone.fulfilled]: (state, action) => {
      state.isLoaded = true;
      // state.user = action.payload
    },
    [changePhone.rejected]: (state, action) => {
      state.isLoaded = true;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [changeAvatar.fulfilled]: (state, action) => {
        state.user = action.payload
    },
      [deleteAvatar.fulfilled]: (state, action) => {
          state.user = action.payload
      }
  }
})

export default profileSlice.reducer
